import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import api from '../../config/axions.config';
import { toast } from 'sonner';
import FeeRecordTable from './FeeRecordTable';
import Swal from 'sweetalert2';
import { showDate } from '../../constant';
import { IoMdClose } from "react-icons/io";

const ViewStudentDetail = () => {
  var getInfo = localStorage.getItem('User') || "{}";
  let admin = JSON.parse(getInfo);
  let location = useLocation();
  let navigate = useNavigate();
  let data = location?.state;

  const [tutorList, setTutorList] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCourse, setIsOpenCourse] = useState(false);

  const [studentFullData, setStudentFullData] = useState([]);
  const [admissionTypeList, setAdmissionTypeList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [payment_typeList, setPayment_typeList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [installmentList, setInstallmentList] = useState([]);
  // student personal details
  const [studentTotalFee, setStudentTotalFee] = useState(0)
  const [studentPaiedFee, setStudentPaiedFee] = useState(0)
  const [studentRemainingFee, setStudentRemainingFee] = useState(0)

  // const [studentId,setStudentId] = useState(data._id)
  /* const [admission_type, setAdmission_type] = useState(''); */
  const [duration, setDuration] = useState()
  const [tutor, setTutor] = useState([]);
  const [course_id, setCourse_id] = useState('')
  const [stratDate, setStartDate] = useState('')
  const [startDate, setStratDate] = useState('')
  const [endDate, setEndDate] = useState('');
  const [endPopupDate, setEndPopupDate] = useState('')
  const [totalFee, setTtalFee] = useState()
  const [installment, setInstallment] = useState();
  const [total_fee, setTotal_fee] = useState();
  const [duration_type, setDuration_type] = useState('')

  // payment step Variables
  const [enrollmentData, setEnrollmentData] = useState({})
  const [payment_type, setPayment_type] = useState('');
  const [ScreenShort, setScreenShort] = useState({ Bytes: '', filename: '' })
  const [totalAmount, setTotalAmount] = useState()
  const [paymentDate, setPaymentDate] = useState('');
  const [installmentNo, setInstallmentNo] = useState(0)
  const [TransactionID, setTransactionID] = useState('')
  const [admissionType, setAdmissionType] = useState('');
  const [enrollmentId, setEnrollmentId] = useState('')
  const [courseId, setCourseId] = useState('');
  const [sellectedEnrollmentId, setSellectedEnrollmentId] = useState({});
  const [tutorFieldValue,setTutorFieldValue] = useState('');
  const [activeEditTab, setActiveEditTab] = useState(false)
  const [admission_type, setAdmission_type] = useState({
      type: "Please Chose Course",
      id: ""
    })

  function countTotalFee(data) {
    let total = 0
    let paied = 0

    for (let i = 0; i < data.length; i++) {
      for (let e = 0; e < data[i].feeRecord.length; e++) {
        paied += data[i].feeRecord[e].total_amount
      }
      total += data[i].total_fee
    }
    setStudentTotalFee(total);
    setStudentPaiedFee(paied);
    setStudentRemainingFee(total - paied);
  }

  async function getCourseList() {
    try {
      let responce = await api.get("course")
      if (responce?.data.status) {
        setCourseList(responce.data.data.courses);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleTutorFileKey = (e) =>{
    if (e.key === "Enter") {
      if (tutorFieldValue) {
        tutor.push(tutorFieldValue);
        setTutorFieldValue('');        
      }
      else{
        toast.error("input Language field")
      }
    }
  }
  const handleTutorListItemRemove = (e) =>{
    let result = tutor.filter((item)=> item !== e.target.id)
    setTutor(result);
  }

  async function getAdmissionType() {
    try {
      let responce = await api.get("admissionType")
      if (responce?.data.status) {
        setAdmissionTypeList(responce.data.data.AdmissionTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function GetStudentData(data) {
    try {
      let response = await api.get("enrollment/get-student-data", {
        params: { studentId: data?._id }
      });
      if (response.data.status) {
        setStudentFullData(response?.data.data);
        setEnrollmentDataDir(response?.data.data[activeTab]);
        countTotalFee(response.data?.data);
      }
      else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data.message)
    }
  }
  async function getPaymentType() {
    try {
      let responce = await api.get("paymentType")
      if (responce?.data.status) {
        setPayment_typeList(responce.data.data.PaymentTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  const handleOpenCoursePopup = () => {
    setIsOpenCourse(true);
  }
  const handleClosePopup = () => {
    setIsOpen(false);
  }
  const handleCloseCoursePopup = () => {
    setIsOpenCourse(false);
  }
  const tabClick = (index) => {
    setActiveTab(index);
  };
  const openEdit = () => {
    setActiveEditTab(true)
  }
  const closeEdit = () => {
    setActiveEditTab(false)
  }
  async function getTutor() {
    try {
      let responce = await api.get("staff")
      if (responce?.data.status) {
        setTutorList(responce.data.data.Tutor);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  // set installment no
  function setEnrollmentDataDir(data) {
    let arr = [];
    for (let i = 1; i < data.no_of_installments + 1; i++) {
      arr.push(i)
    }
    setEnrollmentData(data);
    setInstallmentList(arr)
  }
  //  STUDENT ENROLLMENT  
  async function submitEnrollment() {
    Swal.fire({
      title: "Create New Enrollment?",
      text: "Do you want to Create new Enrollment",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (!tutor || !installment || !duration || !admission_type || !course_id || !totalFee || startDate || endPopupDate || !duration_type) toast.error("Some fileds are emplty");
          let responce = await api.post('enrollment', { student_id: data._id, admission_type, course_id, tutor, no_of_installments: installment, start_date: startDate, end_date: endPopupDate, total_fee: total_fee, duration, enrolled_by: admin._id, duration_type});
          if (responce.data.status) {
            toast.success(responce.data.message);
            setIsOpenCourse(false)
          }
          else {
            toast.error(responce.data.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
          console.log(error);
        }
      } else {
        toast.error("OK! request cancle.");
      }
    });
  }

  // payment Fee 
  async function addPaymentDetails(e) {
    Swal.fire({
      title: "You Collection Fee ?",
      text: "Do you Create new Fee Record",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!enrollmentData || !payment_type || !paymentDate || !installmentNo || !totalAmount || !TransactionID) toast.error("Some fileds are emplty");
        try {
          const formData = new FormData();
          formData.append("student_id", data._id);
          formData.append("enrolment_id", enrollmentId);
          formData.append("installment", installmentNo);
          formData.append("payment_type", payment_type);
          formData.append("payment_date", paymentDate);
          formData.append("transactionID", TransactionID);
          formData.append("total_amount", totalAmount);
          formData.append("admissionType", admission_type.id);
          formData.append("course", courseId);
          formData.append("created_by", admin._id);
          if (ScreenShort.filename) formData.append("screenShort", ScreenShort.Bytes);

          let responce = await api.post('feecollection', formData);
          if (responce.data.status) {
            toast.success(responce.data.message);
          }
          else {
            toast.error(responce.data.message);
          }

        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for (let item of list) {
            toast.warning(item.msg)
          }
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }


  function setCourse(e) {
    setCourse_id(e.target.value);
    setTutorFieldValue(e.target.selectedOptions[0].getAttribute('tutor'));
    setDuration(e.target.selectedOptions[0].getAttribute('duration'));
    setDuration_type(e.target.selectedOptions[0].getAttribute('duration_type'));
    setTotal_fee(e.target.selectedOptions[0].getAttribute('total_fee'))
  }

  useEffect(() => {
        if (startDate && duration > 0 && duration_type) {
          const start = new Date(startDate);
          if(duration_type === "months"){
            start.setMonth(start.getMonth() + parseInt(duration)); // Adding the duration in months
          }else if(duration_type === "days"){
            start.setDate(start.getDate() + parseInt(duration)); // Adding the duration in days
          }
          setEndPopupDate(start.toISOString().split('T')[0]); // Format to YYYY-MM-DD
        } else {
          setEndPopupDate(''); // Clear end date if inputs are invalid
        }
      }, [startDate, duration, duration_type]);

  useEffect(() => {
    getTutor();
    getCourseList();
    getAdmissionType()
    GetStudentData(data);
    getPaymentType();
  }, [data])

  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56 relative'>
      {
        isOpen && (
          <div className='bg-black bg-opacity-50 absolute w-full h-screen z-[999]'>
            <div id="addNewCourseModal" aria-labelledby="modal-title" role="dialog" aria-hidden="true" tabIndex="-1">
              <div className="modal-overlay" tabIndex="-1"></div>
              <div className="modal-dialog modal-dialog-scrollable md:max-w-3xl xl:max-w-4xl">
                <div className="modal-content" role="document">
                  <div className="modal-header">
                    <h5 className="mr-12 text-lg font-bold truncate">
                      Payment Collection
                    </h5>

                    <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={handleClosePopup}>
                      <span className="sr-only">
                        Close
                      </span>
                      <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="modal-body">
                    <form action="#" method="POST">
                      <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                        <div className="col-span-2">
                          <label htmlFor="">
                            Student Name
                          </label>
                          <div className="mt-1 ">
                            <input type="text" value={data.firstname + " " + data.lastname} />
                          </div>
                        </div>

                        <div className="col-span-2">
                          <label htmlFor="">
                            Student Id
                          </label>
                          <div className="mt-1 ">
                            <input type="text" value={data._id} />
                          </div>
                        </div>

                        <div className="col-span-2">
                          <label htmlFor="">
                            Student Contact
                          </label>
                          <div className="mt-1 ">
                            <input type="text" value={data.mobile} />
                          </div>
                        </div>

                        <div className="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Course <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <select onChange={(e) => { setEnrollmentId(e.target.value); setCourseId(e.target.selectedOptions[0].getAttribute('courseID'));setAdmission_type({
                                    id: e.target.selectedOptions[0].getAttribute('admissionTypeId'), type: e.target.selectedOptions[0].getAttribute('admissionTypeName')
                                  }) }} >
                              <option value={null}>
                                {"Please choose Course"}
                              </option>
                              {
                                studentFullData?.map(item => (
                                  <option value={item._id} courseID={item.courseData._id} admissionTypeId={item.admissionType._id} admissionTypeName={item.admissionType.type} >
                                    {item.courseData.name}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                        </div>

                        <div className="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Admission Type <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <input type="text" value={admission_type.type} />
                          </div>
                        </div>

                        <div className="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Payment Type <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <select onChange={(e) => setPayment_type(e.target.value)} >
                              <option value={null}>
                                {"Please choose Payment Type"}
                              </option>
                              {
                                payment_typeList?.filter((item) => item.is_active === true)?.map(item => (
                                  <option value={item._id}>
                                    {item.type}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                        </div>

                        <div className="col-span-2">
                          <label htmlFor="">
                            Payment Date
                          </label>
                          <div className="mt-1 ">
                            <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                          </div>
                        </div>

                        <div className="col-span-2">
                          <label htmlFor="">
                            Total Amount
                          </label>
                          <div className="mt-1">
                            <div className="relative rounded-md shadow-sm">
                              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <span className="text-gray-500 sm:text-sm">
                                  &#8377;
                                </span>
                              </div>
                              <input type="number" value={totalAmount} onChange={(e) => setTotalAmount(e.target.value)} className="!pl-7 !pr-12" required />
                              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                <span className="text-gray-500 sm:text-sm">
                                  RS
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-2">
                          <label htmlFor="">
                            Installments
                          </label>
                          <div className="mt-1 ">
                            {/* <select onChange={(e) => setInstallmentNo(e.target.value)} >
                              <option value={null}>
                                {"Please choose Installment"}
                              </option>
                              {
                                installmentList.map(item => (
                                  <option value={item}>
                                    {item}
                                  </option>
                                ))
                              }
                            </select> */}
                            <input type="text" value={installment} onChange={(e) => setInstallmentNo(e.target.value)} />
                          </div>
                        </div>

                        {payment_type === "67ce808f38f89d08017195d1" ? ""
                          :
                          (<div className="col-span-2 sm:col-span-4">
                            <label htmlFor="">
                              Upload Screenshot
                            </label>
                            <div className="mt-1">
                              <div className='flex'>
                                <input type="file" className='' onChange={(e) => setScreenShort({ Bytes: e.target.files[0], filename: URL.createObjectURL(e.target.files[0]) })} />
                                <img src={ScreenShort.filename} alt='Screenshot' className='w-1/6' />
                              </div>
                            </div>
                          </div>)
                        }

                        {payment_type === "67ce808f38f89d08017195d1" ? " "
                          :
                          (<div className="col-span-4">
                            <label htmlFor="">
                              {payment_type === "67aafcf0e4c3382b848d9abb" ? "Cheque No." : "Transaction Id"}
                            </label>
                            <div className="mt-1 ">
                              <input type="text" value={TransactionID} onChange={(e) => setTransactionID(e.target.value)} />
                            </div>
                          </div>)
                        }
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer">
                    <div className="flex items-center justify-end space-x-4">
                      <button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close Modal" onClick={handleClosePopup}>
                        Discard
                      </button>
                      <button type="button" onClick={addPaymentDetails} className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {
        isOpenCourse && (
          <div className='bg-black bg-opacity-50 absolute w-full h-screen z-[999]'>
            <div id="addNewCourseModal" aria-labelledby="modal-title" role="dialog" aria-hidden="true" tabIndex="-1">
              <div class="modal-overlay" tabIndex="-1"></div>
              <div class="modal-dialog modal-dialog-scrollable md:max-w-4xl xl:max-w-5xl">
                <div class="modal-content" role="document">
                  <div class="modal-header">
                    <h5 class="mr-12 text-lg font-bold truncate">
                      Enroll in New Course
                    </h5>

                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" onClick={handleCloseCoursePopup}>
                      <span class="sr-only">
                        Close
                      </span>
                      <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div class="modal-body pb-10">
                    <form action="#" method="POST">
                      <div class="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                        <div class="col-span-2">
                          <label htmlFor="">
                            Student Name
                          </label>
                          <div class="mt-1 ">
                            <input type="text" value={data.firstname + " " + data.lastname} />
                          </div>
                        </div>

                        <div class="col-span-2">
                          <label htmlFor="">
                            Student Id
                          </label>
                          <div class="mt-1 ">
                            <input type="text" value={data._id} />
                          </div>
                        </div>

                        <div class="col-span-2">
                          <label htmlFor="">
                            Student Contact
                          </label>
                          <div class="mt-1 ">
                            <input type="number" value={data.mobile} />
                          </div>
                        </div>

                        <div class="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Admission Type <span class="text-primary-600">*</span>
                          </label>
                          <div class="mt-1">
                            <select onChange={(e) => { setAdmission_type(e.target.value) }} >
                              <option value={null}>
                                {"Please choose Admission Type"}
                              </option>
                              {
                                admissionTypeList?.map(item => (
                                  <option value={item._id}>
                                    {item.type}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                        </div>

                        <div class="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Course <span class="text-primary-600">*</span>
                          </label>
                          <div class="mt-1">
                            <select onChange={(e) => setCourse(e)} >
                              <option value={null}>
                                {"Please choose Course"}
                              </option>
                              {
                                courseList?.filter((item) => item.admissionType === admission_type)?.map(item => (
                                  <option value={item._id} tutor={item.tutor} duration={item.duration} duration_type={item.duration_type} total_fee={item.base_fee} >
                                    {item.name}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                        </div>

                        <div class="col-span-1 sm:col-span-4 md:col-span-1">
                        <label htmlFor="">
                              Duration Type
                            </label>
                            <div class="mt-1">
                            <select name="" id="" onChange={(e) => setDuration_type(e.target.value)}>
                            <option value="">
                              {duration_type}
                            </option>
                            <option value="days">
                              Days
                            </option>
                            <option value="months">
                              Months
                            </option>
                          </select>
                            </div>
                          </div>

                          <div class="col-span-1 sm:col-span-4 md:col-span-1">
                          <label htmlFor="">
                            Course Duration
                          </label>
                          <div class="mt-1">
                            <input type="number" value={duration} onChange={(e) => { setDuration(e.target.value) }} />
                          </div>
                        </div>

                        <div class="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Total Fees <span class="text-primary-600">*</span>
                          </label>
                          <div class="mt-1">
                            <div class="relative rounded-md shadow-sm">
                              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <span class="text-gray-500 sm:text-sm">
                                  &#8377;
                                </span>
                              </div>
                              <input type="number" value={total_fee} onChange={(e) => setTotal_fee(e.target.value)} name="" id="" placeholder="" class="!pl-7 !pr-12" required />
                              <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                <span class="text-gray-500 sm:text-sm">
                                  RS
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Enrolled By <span class="text-primary-600">*</span>
                          </label>
                          <div class="mt-1">
                            <input type="text" value={admin.firstname + " " + admin.lastname} class="" />
                          </div>
                        </div>

                        <div className='col-span-2 sm:col-span-4 md:col-span-2'>
                          <label htmlFor="">
                            Start Date <span class="text-primary-600">*</span>
                          </label>

                          <div class="mt-1">
                            <div class="relative rounded-md shadow-sm">
                              <input type="date" value={startDate} onChange={(e) => setStratDate(e.target.value)} placeholder="" />
                            </div>
                          </div>
                        </div>


                        <div className='col-span-2 sm:col-span-4 md:col-span-2'>
                          <label htmlFor="">
                            End Date <span class="text-primary-600">*</span>
                          </label>

                          <div class="mt-1">
                            <div class="relative rounded-md shadow-sm">
                              <input type="date" value={endPopupDate} /* onChange={(e) => setStartDate(e.target.value)} */ placeholder="" />
                            </div>
                          </div>
                        </div>

                        <div class="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Tutor
                          </label>
                          <div class="mt-1">
                            {/* <select onChange={(e) => setTutor(e.target.value)} >
                              <option value={null}>
                                {tutor}
                              </option>
                              {
                                tutorList?.map(item => (
                                  <option value={item._id}>
                                    {item.firstname + " " + item.lastname}
                                  </option>
                                ))
                              }
                            </select> */}
                            {/* <input type="text" value={tutor} onChange={(e) => setTutor(e.target.value)} /> */}
                            <input type="text" value={tutorFieldValue} onChange={(e)=>setTutorFieldValue(e.target.value)} onKeyDown={(e)=>handleTutorFileKey(e)} />
                              <div className='w-full p-2 my-1 mb-2 flex-1 sm:text-sm rounded-md flex flex-wrap gap-2 overflow-hidden !absolute'>
                              {
                                tutor?.map((item,index)=><p key={index} className='px-2 items-center gap-1 flex justify-center bg-sky-200  rounded-3xl' >{item}<IoMdClose id={item} onClick={(e)=>handleTutorListItemRemove(e)} width={"10px"}/></p>)
                              }
                            </div>
                          </div>
                        </div>

                        <div class="col-span-2">
                          <label htmlFor="">
                            Installments
                          </label>
                          <div class="mt-1 ">
                            <input type="number" value={installment} onChange={(e) => setInstallment(e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="modal-footer">
                    <div class="flex items-center justify-end space-x-4">
                      <button type="button" onClick={() => setIsOpenCourse(false)} class="btn btn-light" data-dismiss="modal" aria-label="Close Modal">
                        Discard
                      </button>
                      <button type="button" onClick={submitEnrollment} class="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )
      }
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <div className='z-0'>
          <div className="xl:flex xl:items-center xl:justify-between">
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Student Details
            </h1>
            <button type="button" className="btn btn-white" onClick={() => navigate('/dashboard/students/')}>
              Back
            </button>
          </div>

          <div className="mt-8 md:mt-6 sm:flex sm:items-center sm:space-x-6 relative">
            <div className="flex items-center space-x-3">
              <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
              </svg>
              <span className="text-gray-600">
                Student Id
              </span>
            </div>
            <div className="flex items-center mt-3 space-x-3 sm:mt-0">
              <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              </svg>
              <span className="text-gray-600">
                Created - <span>{showDate(data.created_at)}</span>
              </span>
            </div>
            <div className="flex items-center mt-3 space-x-3 sm:mt-0">
              <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              </svg>
              <span className="text-gray-600">
                Updated - <span>{showDate(data.update_at)}</span>
              </span>
            </div>
            <div className="flex items-center mt-3 space-x-3 sm:mt-0">
              <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              </svg>
              <span className="text-gray-600">
                Deleted - <span>{showDate(data.deleted_at)}</span>
              </span>
            </div>
          </div>

          <div className="mt-2 space-y-6">
            <div className="overflow-hidden bg-white rounded-lg shadow">
              <div className="px-4 py-5 sm:p-6">
                <div className="grid xl:grid-cols-6 gap-y-10">
                  <div className="xl:col-span-4 xl:pr-8 order-1 lg:order-1 md:order-2 sm:order-2 xs:order-2">
                    <div className="space-y-6">

                      {/* course list nav */}
                      <div className=" border-b border-gray-200">
                        <nav className="flex -mb-px justify-between" aria-label="Tabs">
                          <div className='flex space-x-4 sm:space-x-8 overflow-x-auto'>
                            {
                              studentFullData?.map((item, index) => (
                                <div
                                  key={item.courseData?._id}
                                  onClick={() => { tabClick(index); setEnrollmentDataDir(studentFullData[index]); }}
                                  className={
                                    activeTab === index
                                      ? "active text-primary-600 border-b-2 border-primary-600"
                                      : ""
                                  }
                                >
                                  <div
                                    title=""
                                    className="px-1 py-3 text-sm font-medium whitespace-nowrap hover:cursor-pointer"
                                    aria-current="page"
                                  >
                                    {item.courseData?.name}
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                          <div>
                            <button type="button" onClick={handleOpenCoursePopup} className="w-full btn sm:w-auto btn-primary leading-icon mb-5 md:mb-5 lg:mb-0" data-toggle="modal" data-target="#addClassModal">
                              <svg stroke="currentColor" viewBox="0 0 256 256">
                                <line x1="40" y1="128" x2="216" y2="128" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                <line x1="128" y1="40" x2="128" y2="216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                              </svg>
                              Add Course
                            </button>
                          </div>
                        </nav>
                      </div>

                      {/* Student course detail information render */}
                      {
                        studentFullData?.map((item, index) => (
                          activeTab === index &&
                          <div key={item?._id}>
                            <div>
                              <div className="flex items-center">
                                <p className="font-medium">
                                  Course Details
                                </p>
                              </div>

                              <div className="mt-3 space-y-3">
                                <div className="bg-white border border-gray-100 rounded-lg shadow-md">
                                  <div className="px-4 py-5 sm:p-6">
                                    <div className="grid grid-cols-6 gap-5 md:grid-cols-6">
                                      <div className="col-span-3 md:col-span-3 md:order-1">
                                        <p className="text-sm text-gray-600">
                                          Course Name
                                        </p>
                                        <p className="mt-1 text-lg leading-tight text-primary-600">
                                        {item?.courseData.name}
                                        </p>
                                      </div>
                                      <div className="col-span-2 md:col-span-2 md:order-1">
                                        <p className="text-sm text-gray-600">
                                          Admission Type
                                        </p>
                                        <p className="mt-1 text-lg leading-tight text-primary-600">
                                          {item?.admissionType.type}
                                        </p>
                                      </div>
                                      <div className='col-span-1 md:col-span-1 md:order-1'>
                                        <div className="flex items-center space-x-2">
                                          <label htmlFor="">
                                            Status
                                          </label>
                                          <div className="toggle-switch">
                                            <input type="checkbox" checked={data.is_active} id="toggleSwitch"  tabIndex="0" readOnly/>
                                            <label htmlFor="toggleSwitch"></label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="grid grid-cols-1 gap-5 mt-5 sm:grid-cols-6 xl:grid-cols-6">
                                      <div>
                                        <p className="text-sm text-gray-600">
                                          Start Date
                                        </p>
                                        <p className="mt-1">
                                          {showDate(item.start_date)}
                                        </p>
                                      </div>

                                      <div>
                                        <p className="text-sm text-gray-600">
                                          End Date
                                        </p>
                                        <p className="mt-1">
                                          {showDate(item.end_date)}
                                        </p>
                                      </div>

                                      <div className=''>
                                        <p className="text-sm text-gray-600">
                                          Duration
                                        </p>
                                        <p className="mt-1">
                                          {item?.duration}
                                        </p>
                                      </div>
                                      <div>
                                        <p className="text-sm text-gray-600">
                                          Tutor
                                        </p>
                                        <p className="mt-1">
                                          {item?.tutor}
                                        </p>
                                      </div>
                                      <div>
                                        <p className="text-sm text-gray-600">
                                          Enrolled By
                                        </p>
                                        <p className="mt-1">
                                          {admin.firstname + " " + admin.lastname}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <FeeRecordTable data={item} paymentType={payment_typeList} enrollment={enrollmentData} />
                          </div>
                        ))
                      }
                    </div>
                  </div>
                  {/* student information */}
                  <div className="xl:border-l xl:border-gray-200 xl:col-span-2 xl:pl-8 order-2 lg:order-2 md:order-1 sm:order-1 xs:order-1">
                    <div className="flex items-center justify-between">
                      <p className="font-medium">
                        Student Information
                      </p>
                    </div>

                    <div className='flex justify-between  !items-end'>
                      <h4 className="mt-4 text-2xl font-bold text-primary-600">
                        {data.firstname + " " + data.lastname}
                      </h4>

                      <div className="flex items-center space-x-2">
                        <label htmlFor="">
                          Status
                        </label>
                        <div className="toggle-switch">
                          <input type="checkbox" checked={data.is_active} id="toggleSwitch" tabIndex="0" readOnly/>
                          <label htmlFor="toggleSwitch"></label>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 mt-8 gap-x-8 gap-y-6">

                      <div className='col-span-2'>
                        <p className="text-sm text-gray-600">
                          Student Id
                        </p>
                        <p className="mt-1 text-lg leading-tight text-primary-600">
                          {data._id}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-600">
                          Student Contact
                        </p>
                        <p className="mt-1">
                          {data.mobile}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-600">
                          Parents Contact
                        </p>
                        <p className="mt-1">
                          {data.parent_mobile}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-600">
                          Email
                        </p>
                        <p className="mt-1">
                          {data.email}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-600">
                          Address
                        </p>
                        <p className="mt-1">
                          {data.address}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-600">
                          Collage
                        </p>
                        <p className="mt-1">
                          {data.collage_info.name}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-600">
                          Stream
                        </p>
                        <p className="mt-1">
                          {data.stream_info.name}
                        </p>
                      </div>

                      <div>
                        <p className="mt-1">
                          {data.is_active ?
                            (<span className='px-4 py-2 bg-green-500 rounded-md text-white text-center'>Active</span>)
                            :
                            (<span className='px-2 py-3 bg-red-500 rounded-md text-white text-center'>Deactive</span>)}
                        </p>
                      </div>

                      <div>
                        <button type="button" className="btn btn-primary px-8 py-2" onClick={() => setIsOpen(true)}>
                          Pay
                        </button>
                      </div>
                    </div>

                    <hr className="my-6 border-gray-200" />

                    <div>
                      <div className="flex items-center">
                        <p className="font-medium">
                          Fees Collection Details
                        </p>
                      </div>

                      <div className="mt-3 space-y-3">
                        <div className="grid grid-cols-2 mt-5 gap-x-8 gap-y-6">
                          <div className="col-span-2">
                            <p className="text-sm ">
                              Total Fees
                            </p>
                            <p className="mt-1 text-lg leading-tight text-primary-600">
                              {studentTotalFee} 
                            </p>
                          </div>

                          <div className="">
                            <p className="text-sm">
                              Paid Fees
                            </p>
                            <p className="mt-1">
                              {studentPaiedFee}
                            </p>
                          </div>

                          <div className="">
                            <p className="text-sm">
                              Remaining Fees
                            </p>
                            <p className="mt-1">
                              {studentRemainingFee}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default ViewStudentDetail
